module.exports = __WEBPACK_EXTERNAL_MODULE__715__;